import {$timestampLocalStr, $isXunMengTu} from '@/util/util'

export default {
  // , options
  install (Vue) {
    /**
     * 格式化时间字符串
     */
    // console.log(options)
    Vue.prototype.$_timestampLocalStr = str => {
      return $timestampLocalStr(str)
    }
    Vue.prototype.$_isXunMengTu = () => {
      return $isXunMengTu()
    }
  }
}